import { PageContent, Box, Header, Heading, Paragraph, Image } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import Fits1 from "../images/fits1.png";
import Fits2 from "../images/fits2.png";

const Attire: React.FC<PropsWithChildren> = () => {
    return (
        <AppPage>
            <>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_background' }} >
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "xlarge" }}>
                        <Header direction="column" gap="small" overflow="hidden" className="title-medium">
                            <Heading weight="normal" margin="none" color="cream" style={{letterSpacing: "1px"}}>attire</Heading>
                        </Header>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" direction="column" pad="large">
                        <Paragraph color="cream" textAlign="center">For the main event on Saturday, wear an outfit of your choice that is <strong>all one color</strong>. Bonus points for bright colors! Bonus points if your shoes match! You can dress super casually or fancy schmancy. Wear what makes you happy!
                        </Paragraph>
                        <Paragraph color="cream" textAlign="center"><strong>Avoid wearing black or white</strong> so that our esteemed guests (me) feel cool and different.</Paragraph>
                      </Box>
                      <Box pad={{horizontal:"xsmall", vertical:"large"}}>
                        <Image
                            fit="cover"
                            src={Fits1}
                        
                            style={{ maxWidth: "1200px", width: "100%" }}
                            alignSelf="center"
                            margin="xsmall"
                        />
                        <Image
                            fit="cover"
                            src={Fits2}
                            style={{ maxWidth: "1200px", width: "100%" }}
                            alignSelf="center"
                            margin="xsmall"
                        />
                        </Box>
                </PageContent>
            </>
        </AppPage>
    );
}

export default Attire;
